<div class="Modal ModalEsqueciSenha" style="max-width: 448px">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <span class="material-icons"> {{ data.icon }} </span>
      <p>{{ data.textIcon }}</p>
    </div>
    <span class="material-icons float-end CloseModal" (click)="onNoClick()">
      close
    </span>
  </div>

  <div class="ModalContent">
    <h1 class="TtlModal text-start">
      {{ data.title }}
    </h1>
    <p class="TxtModal text-start">{{ data.text }}</p>
  </div>

  <div class="ModalFooter" *ngIf="data.textExtra != ''">
    <p class="TxtModal text-start">{{ data.textExtra }}</p>
  </div>

  <div class="col-mb">
    <div class="row">
      <div class="col d-none d-md-block d-lg-block"></div>
      <div class="col col-md-8">
        <p class="float-start">Gostaria de receber via Whatsapp.</p>
        <mat-slide-toggle
          class="float-end"
          (change)="smsCode = !smsCode"
        ></mat-slide-toggle>
      </div>
      <div class="col d-none d-md-block d-lg-block"></div>
    </div>
  </div>

  <div class="ModalContent">
    <div class="row">
      <button mat-button class="Btn BtnPadrao" (click)="onClick()">
        Enviar senha
        <span class="material-icons"> east </span>
      </button>
    </div>
  </div>

  <div class="row" *ngIf="data.linkAdress != '' && data.textLink != ''">
    <div class="col text-center ModalFooter">
      <a [routerLink]="data.linkAdress" mat-dialog-close class="mt-24">{{
        data.textLink
      }}</a>
    </div>
  </div>
</div>
